/**
 * Accept only real, secure, absolute public website URLs for embedded references.
 * Never load placeholder or documentation-only hosts as portfolio previews.
 */
export function validPreviewUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    const parsed = new URL(value.trim());
    const hostname = parsed.hostname.toLowerCase().replace(/\.$/, '');
    if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return '';
    if (parsed.username || parsed.password) return '';
    if (['example.com','example.org','example.net','www.example.com','www.example.org','www.example.net','localhost'].includes(hostname)) return '';
    if (hostname.endsWith('.example') || hostname.endsWith('.test') || hostname.endsWith('.invalid') || hostname.endsWith('.localhost')) return '';
    return parsed.href;
  } catch {
    return '';
  }
}